<div class="form-global-policy-exchange-center">
    <div class="pb-9 pl-3">
        <policy-exchange-center (chooseTemplate)="onChooseTemplate($event)"></policy-exchange-center>
    </div>

    <div class="mon-dialog-footer">

    </div>
</div>
